import React from 'react';
import { Stack, IconButton, Tooltip } from '@mui/material';
import { Delete, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

interface Props {
  rowIndex: number;
  rowsCount: number;
  onRemove: (index: number) => void;
  onMove: (from: number, to: number) => void;
}

export const LineItemActionsCell = ({ rowIndex, rowsCount, onMove, onRemove }: Props) => (
  <Stack direction="row" gap="0.5rem" alignItems="center">
    <Tooltip title="Move row down">
      <IconButton
        size="small"
        color="primary"
        className="icon-btn-bordered"
        disabled={rowIndex + 1 > rowsCount - 1}
        onClick={() => onMove(rowIndex, rowIndex + 1)}
      >
        <KeyboardArrowDown />
      </IconButton>
    </Tooltip>

    <Tooltip title="Move row up">
      <IconButton
        size="small"
        color="primary"
        disabled={!rowIndex}
        className="icon-btn-bordered"
        onClick={() => onMove(rowIndex, rowIndex - 1)}
      >
        <KeyboardArrowUp />
      </IconButton>
    </Tooltip>

    <IconButton className="icon-btn-bordered" size="small" color="error" onClick={() => onRemove(rowIndex)}>
      <Delete />
    </IconButton>
  </Stack>
);
